import { HttpParams } from '@angular/common/http';

export class IntegrationClienteGrupo {

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }
        // Execução manual
        params = params.append('manual', 'true');

        return params;
    }

    clear() { }
}
